import { instance } from './axios.instance'
import { AUTH_ENDPOINT } from './endpoints'

/**
 * 로그인
 * POST /api/auth/login
 * @param {Object} params
 * @param {string} params.id - 아이디
 * @param {string} params.password - 비밀번호
 */
export const login = async ({ id, password }) =>
    instance.post(AUTH_ENDPOINT.LOGIN, { id, password }, { skipAuthInterceptor: true })

/**
 * 강사 회원가입
 * POST /api/auth/register
 * @param {Object} params
 * @param {string} params.region - 지역
 * @param {string} params.name - 이름
 * @param {string} params.birth - 생년월일 (YYMMDD)
 * @param {string} params.gender - 성별 ("남" or "여")
 * @param {string} params.phone - 연락처 (010-1234-5678)
 * @param {string} params.email - 이메일
 * @param {string} params.passwd - 비밀번호
 */
export const register = ({ regionId, name, birth, gender, phone, email, passwd }) =>
    instance.post(AUTH_ENDPOINT.REGISTER, { regionId, name, birth, gender, phone, email, passwd })

/**
 * 로그아웃
 * GET /api/auth/logout
 */
export const logout = () => instance.get(AUTH_ENDPOINT.LOGOUT)

/**
 * 비밀번호 찾기 (이메일로 임시 비밀번호 발송)
 * GET /api/auth/password/find?email=
 * @param {Object} params
 * @param {string} email - 이메일 주소
 */
export const findPassword = ({ email }) => instance.get(AUTH_ENDPOINT.FIND_PW, { params: { email } })

/**
 * 비밀번호 변경
 * PATCH /api/auth/edit/pw
 * @param {Object} params
 * @param {string} params.id - 계정 아이디
 * @param {string} params.password - 변경할 비밀번호
 */
export const editPassword = ({ id, password }) => instance.patch(AUTH_ENDPOINT.EDIT_PW, { id, password })

/**
 * 이메일 인증번호 확인
 * GET /api/auth/mail/check?email=&number=
 * @param {Object} params
 * @param {string} params.email - 이메일 주소
 * @param {string} params.number - 인증번호
 */
export const checkMail = ({ email, number }) => instance.get(AUTH_ENDPOINT.CHECK_MAIL, { params: { email, number } })

/**
 * 이메일 인증번호 발송
 * GET /api/auth/mail/send?email=
 * @param {Object} params
 * @param {string} email - 이메일 주소
 */
export const sendMail = ({ email }) => instance.get(AUTH_ENDPOINT.SEND_MAIL, { params: { email } })

/**
 * 비밀번호 확인
 * POST /api/auth/confirm/pw
 * @param {Object} params
 * @param {string} id - 아이디
 * @param {string} password - 비밀번호
 */
export const confirmPassword = ({ id, password }) => instance.post(AUTH_ENDPOINT.CONFIRM_PW, { id, password })
